// JsFromEnums CacheKey 1920fad9278a0068226cd9dbdaf21f18
//
// DO NOT MODIFY: This file was automatically generated by JsFromEnums.
export const COLUMN_LITHIC = {
  "min": 8,
  "max": 15,
  "label": "8-15 business days"
}

export const PERFECT_GIFT = {
  "min": 10,
  "max": 14,
  "label": "10-14 business days"
}
